const version = "v1.2.7";
// 正式
const base = {
  baseUrl: 'http://47.104.172.24',
  url:'47.104.172.24',
  baseApi: 'http://newcrown.3gbio.com.cn/newcrown',
  version
};
// 测试
// const base = {
//   baseUrl: 'http://47.104.172.24',
//   url: '47.104.172.24',
//   baseApi: 'http://newcrown.natapp1.cc',
//   version
// };
//
export default base;

